import { createFileRoute } from '@tanstack/react-router';
import AppointmentsPage from '@/pages/AppointmentsPage';

export interface AppointmentsSearch {
  view?: string;
  providers?: string;
  locations?: string;
  statuses?: string;
  search?: string;
  date?: string;
  /** Pre-select this patient when a slot is clicked — set by "Schedule from referral". */
  bookPatientId?: string;
  bookPatientName?: string;
}

export const Route = createFileRoute('/_authenticated/appointments')({
  validateSearch: (raw: Record<string, unknown>): AppointmentsSearch => ({
    view: (raw.view as string) ?? undefined,
    providers: (raw.providers as string) ?? undefined,
    locations: (raw.locations as string) ?? undefined,
    statuses: (raw.statuses as string) ?? undefined,
    search: (raw.search as string) ?? undefined,
    date: (raw.date as string) ?? undefined,
    bookPatientId: (raw.bookPatientId as string) ?? undefined,
    bookPatientName: (raw.bookPatientName as string) ?? undefined,
  }),
  component: AppointmentsPage,
});
